<template>
  <ViewWrapper class="questions">
    <Countdown
      #default="{ indicatorPercentage }"
      :counter-set-time="counterSetTime"
      @countdownFinished="store.endQuestionSectionByTime()"
    >
      <DraggerArea
        #default="{ directionPercentage }"
        class="questions__inner"
        el="section"
        :current-question-index="store.questionIndex"
        @question-answered="answerQuestion"
      >
        <AnimatedText el="h3" class="questions__headline">{{
          currentQuestion.questionLabel
        }}</AnimatedText>

        <div class="questions__answers">
          <ButtonAnswer
            v-for="({ answerLabel }, index) in currentQuestion.questionAnswers"
            :key="index"
            :index="index"
            class="questions__answer"
            :label="answerLabel"
            :drag-percentage="directionPercentage.x + selectionPercentage.x"
            :animation-percentage="toggleSign(index, directionPercentage.x + selectionPercentage.x)"
            :move-x-area="toggleSign(index, movingArea)"
            @question-answered="answerQuestion"
          />
        </div>

        <ProgressFrameBar
          v-show="indicatorPercentage > alertArea"
          class="questions__progress_alert"
          :indicator-percentage="1"
        />

        <ProgressFrameBar :indicator-percentage="indicatorPercentage" />

        <InteractionHint
          v-if="isTouchDevice"
          class="questions__swipe"
          :label="$t('ui.interactionHint.swipe')"
          icon="swipe"
          animation-class="moveLeftRight"
        />
      </DraggerArea>
    </Countdown>
  </ViewWrapper>
</template>
<script>
import { gsap } from 'gsap';
import store, { currentQuestion, currentSection } from '../store';
import { playSound } from '../services/sound';
import { isTouchDevice } from '../utils/helpers';

import AnimatedText from '../components/AnimatedText';
import ButtonAnswer from '../components/ButtonAnswer';
import Countdown from '../components/Countdown';
import DraggerArea from '../components/DraggerArea';
import InteractionHint from '../components/InteractionHint';
import ProgressFrameBar from '../components/ProgressFrameBar';
import ViewWrapper from '../components/ViewWrapper';

const MOVING_AREA = 40;
const ANSWER_TIMEOUT = 0.25;
const ANSWER_SCALING = 0.25;
const DEFAULT_COUNTER_SET_TIME = 25;
const COUNTER_ALERT_AREA = -0.25;
const VIBRATION_TIME = 20;

export default {
  name: 'Questions',

  components: {
    AnimatedText,
    ButtonAnswer,
    Countdown,
    DraggerArea,
    InteractionHint,
    ProgressFrameBar,
    ViewWrapper,
  },

  data() {
    return {
      store,
      counterTime: 0,
      alertArea: COUNTER_ALERT_AREA,
      movingArea: MOVING_AREA,
      selectionPercentage: {
        x: 0,
        y: 0,
      },
    };
  },

  computed: {
    currentQuestion,
    counterSetTime: () => currentSection().sectionTime || DEFAULT_COUNTER_SET_TIME,
    isTouchDevice,
  },

  methods: {
    toggleSign: (index, value) => (index === 0 ? -value : value),

    answerQuestion(index, isButtonClick) {
      if (index === undefined) return;

      playSound('fxA', 'swipe');

      /*
      setTimeout(() => {
        playSound('fxB', 'answer');
      }, 0.5);
      */

      if (navigator.vibrate) {
        navigator.vibrate(VIBRATION_TIME);
      }

      let answerScalingValue = ANSWER_SCALING;
      let transitionTime = ANSWER_TIMEOUT;

      if (!isButtonClick) {
        answerScalingValue = 0;
        transitionTime = 0;
      }

      const self = this;
      gsap.to(self.selectionPercentage, {
        duration: transitionTime,
        x: index === 0 ? -answerScalingValue : answerScalingValue,
        onComplete() {
          self.selectionPercentage.x = 0;
          store.answerQuestion(index);
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$padding: 100px;

.questions {
  background-color: rgba($color-black, $view-overlay-alpha);

  // hide overflow buttons
  overflow: hidden;
}

.questions__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.questions__headline {
  @include question-headline;
  height: 30vh;
  max-height: 250px;
  margin-top: 20vh;

  @include helper__greater($bp-1023) {
    min-height: 15vh;
  }
}

.questions__answers {
  display: flex;
  justify-content: center;
}

.questions__answer {
  & + & {
    margin-left: 60px;
  }
}

.questions__swipe {
  position: absolute;
  left: 50%;
  bottom: 30px;
  transform: translateX(-50%);
}

.questions__progress_alert {
  animation: blinker 1s linear infinite;
}
</style>
